// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import logo from '../assets/images/PlacezioLogo.png';

// const Navbar = () => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [isFixed, setIsFixed] = useState(false);

//     const toggleNavbar = () => {
//         setIsOpen(!isOpen);
//     };

//     const scrollToTop = () => {
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//     useEffect(() => {
//         const handleScroll = () => {
//             if (window.scrollY > 50) {
//                 setIsFixed(true);
//             } else {
//                 setIsFixed(false);
//             }
//         };

//         window.addEventListener('scroll', handleScroll);

//         return () => {
//             window.removeEventListener('scroll', handleScroll);
//         };
//     }, []);

//     return (
//         <nav className={`p-4 bg-white shadow-md ${isFixed ? 'fixed top-0 w-full z-50' : ''}`}>
//             <div className="container mx-auto flex justify-between items-center">
//                 <Link to="/" onClick={scrollToTop}>
//                     <img
//                         src={logo}
//                         alt="Placezio Estate Logo"
//                         className="h-12 w-22 md:h-15 md:w-30 lg:h-18 lg:w-37"
//                     />
//                 </Link>

//                 <div className="hidden md:flex space-x-1">
//                     <Link
//                         to="/"
//                         onClick={scrollToTop}
//                         className="text-[#54BD95]  hover:bg-[#54BD95] hover:text-white hover:bg-opacity-60 px-3 py-3 rounded transition duration-200"
//                         style={{ fontSize: '20px' }}
//                     >
//                         Home
//                     </Link>
//                     <Link
//                         to="/rent-list"
//                         onClick={() => { toggleNavbar(); scrollToTop(); }}
//                         className="block text-[#54BD95]  hover:bg-[#54BD95] hover:text-white hover:bg-opacity-60 px-3 py-3 rounded transition duration-200"
//                         style={{ fontSize: '20px' }}
//                     >
//                         Rent
//                     </Link>

//                     <Link
//                         to="/Sell-property-in-lucknow"
//                         onClick={() => { toggleNavbar(); scrollToTop(); }}
//                         className="block text-[#54BD95]  hover:bg-[#54BD95] hover:text-white hover:bg-opacity-60 px-3 py-3 rounded transition duration-200"
//                         style={{ fontSize: '20px' }}
//                     >
//                         Sell
//                     </Link>



//                     <Link
//                         to="/list-Property"
//                         onClick={() => { toggleNavbar(); scrollToTop(); }}
//                         className="block text-[#54BD95]  hover:bg-[#54BD95] hover:text-white hover:bg-opacity-60 px-3 py-3 rounded transition duration-200"
//                         style={{ fontSize: '20px' }}
//                     >
//                         List Property
//                     </Link>

//                     {/* <Link
//                    to="/project-card" 
//                     onClick={() => { toggleNavbar(); scrollToTop(); }}
//                     className="block text-black  hover:bg-green-900 hover:text-black hover:bg-opacity-60 px-3 py-2 rounded transition duration-200"
//                     style={{ color: '#54BD95' , fontSize: '22px'}}
//                 >
//                     Societies
//                 </Link> */}



//                     <Link
//                         to="/allBlogs"
//                         onClick={scrollToTop}
//                         className="text-[#54BD95]  hover:bg-[#54BD95] hover:text-white hover:bg-opacity-60 px-3 py-3 rounded transition duration-200"
//                         style={{ fontSize: '20px' }}
//                     >
//                         Blogs
//                     </Link>

//                     <Link
//                         to="/requirements"
//                         onClick={scrollToTop}
//                         className="text-[#54BD95]  hover:bg-[#54BD95] hover:text-white hover:bg-opacity-60 px-3 py-3 rounded transition duration-200"
//                         style={{ fontSize: '20px' }}
//                     >
//                         Your Requirement
//                     </Link>

//                 </div>
//                 <button onClick={toggleNavbar} className="md:hidden text-[#54BD95] focus:outline-none">
//                     <svg
//                         className="w-6 h-6"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                         xmlns="http://www.w3.org/2000/svg"
//                     >
//                         {isOpen ? (
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
//                         ) : (
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
//                         )}
//                     </svg>
//                 </button>
//             </div>
//             <div className={`navbar-dropdown ${isOpen ? 'open' : ''} md:hidden`}>
//                 {/* <div className={`${isOpen ? 'block' : 'hidden'}  md:hidden`}> */}

//                 <Link
//                     to="/"
//                     onClick={() => { toggleNavbar(); scrollToTop(); }}
//                     className="block text-[#54BD95] font-bold hover:bg-[#54BD95] hover:text-white hover:bg-opacity-60 px-3 py-2 rounded transition duration-200"
//                 // style={{ color: '#54BD95' }}
//                 >
//                     Home
//                 </Link>
//                 <Link
//                     to="/rent-list"
//                     onClick={() => { toggleNavbar(); scrollToTop(); }}
//                     className="block text-[#54BD95] font-bold hover:bg-[#54BD95] hover:text-white hover:bg-opacity-60 px-3 py-2 rounded transition duration-200"

//                 >
//                     Rent
//                 </Link>

//                 <Link
//                     to="/Sell-property-in-lucknow"
//                     onClick={() => { toggleNavbar(); scrollToTop(); }}
//                     className="block text-[#54BD95] font-bold hover:bg-[#54BD95] hover:text-white hover:bg-opacity-60 px-3 py-2 rounded transition duration-200"

//                 >
//                     Sell
//                 </Link>

//                 <Link
//                     to="/list-Property"
//                     onClick={() => { toggleNavbar(); scrollToTop(); }}
//                     className="block text-[#54BD95] font-bold hover:bg-[#54BD95] hover:text-white hover:bg-opacity-60 px-3 py-2 rounded transition duration-200"

//                 >
//                     List Property
//                 </Link>

//                 <Link
//                     to="/allBlogs"
//                     onClick={() => { toggleNavbar(); scrollToTop(); }}
//                     className="block text-[#54BD95] font-bold hover:bg-[#54BD95] hover:text-white hover:bg-opacity-60 px-3 py-2 rounded transition duration-200"

//                 >
//                     Blogs
//                 </Link>

//                 <Link
//                     to="/requirements"
//                     onClick={() => { toggleNavbar(); scrollToTop(); }}
//                     className="block text-[#54BD95] font-bold hover:bg-[#54BD95] hover:text-white hover:bg-opacity-60 px-3 py-2 rounded transition duration-200"

//                 >
//                     Your Requirement
//                 </Link>
//             </div>
//         </nav>
//     );
// };

// export default Navbar;



import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/PlacezioLogo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isFixed, setIsFixed] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const closeNavbar = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsFixed(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`p-4 bg-white shadow-md ${isFixed ? "fixed top-0 w-full z-50" : ""}`}>
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <Link to="/" onClick={closeNavbar}>
          <img src={logo} alt="Placezio Estate Logo" className="h-12 w-22 md:h-15 md:w-30 lg:h-18 lg:w-37" />
        </Link>

        {/* Desktop Navbar */}
        <div className="hidden md:flex space-x-4">
          {[
            { to: "/", label: "Home" },
            { to: "/appartment_for_rent", label: "Rent" },
            { to: "/Sell-property-in-lucknow", label: "Sell" },
            { to: "/list-Property", label: "List Property" },
            { to: "/allBlogs", label: "Blogs" },
            { to: "/requirements", label: "Your Requirement" }
          ].map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-[#54BD95] hover:bg-[#54BD95] hover:text-white px-3 py-3 rounded transition duration-200"
              style={{ fontSize: "20px" }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button onClick={toggleNavbar} className="md:hidden text-[#54BD95] focus:outline-none">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            {isOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        {/* Mobile Drawer Menu */}
        <div
          className={`fixed top-0 right-0 h-full w-3/4 sm:w-1/2 bg-white shadow-lg transform ${
            isOpen ? "translate-x-0" : "translate-x-full"
          } transition-transform duration-300 ease-in-out z-50 md:hidden`}
        >
          {/* Close Button */}
          <button onClick={closeNavbar} className="absolute top-4 right-4 text-[#54BD95] focus:outline-none">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Menu Items */}
          <div className="mt-4 flex flex-col space-y-4 p-6">
            {[
              { to: "/", label: "Home" },
              { to: "/appartment_for_rent", label: "Rent" },
              { to: "/Sell-property-in-lucknow", label: "Sell" },
              { to: "/list-Property", label: "List Property" },
              { to: "/allBlogs", label: "Blogs" },
              { to: "/requirements", label: "Your Requirement" }
            ].map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={closeNavbar}
                className="block text-[#54BD95] font-bold hover:bg-[#54BD95] hover:text-white px-3 py-2 rounded transition duration-200"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Overlay (closes menu when clicking outside) */}
        {isOpen && <div onClick={closeNavbar} className="fixed inset-0 bg-black opacity-40 md:hidden"></div>}
      </div>
    </nav>
  );
};

export default Navbar;



